import React from 'react';
import { Button, ArrayField, Datagrid, FunctionField, DateField, TextField, TextInput, NumberInput, BooleanInput,
  ArrayInput, SimpleFormIterator, FormDataConsumer, AutocompleteInput, SelectArrayInput, SelectInput, BooleanField,
  useRecordContext } 
  from 'react-admin';
import LinkIcon from '@material-ui/icons/Link';
import { ExpandMore } from '@material-ui/icons';
import { Accordion, AccordionSummary, AccordionDetails, Tabs, Tab, AppBar } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { TabPanel } from './TabPanel';

const prebidBidders = require('../prebidBidderModules.json');
// const prebidUserIds = require('../prebidUserIdModules.json');
const prebidGeneralModules = require('../prebidGeneralModules.json');
const prebidRecommendedModules = require('../prebidRecommendedModules.json');
const prebidVendorSpecificModules = require('../prebidVendorSpecificModules.json');
const prebidBaseModules = require('../prebidBaseModules.json');

const prebidGranularityChoices = [
  { id: 'high', name: 'high', desc: 'High (Default) increment: 0.01 cap: 20.00' },
  { id: 'medium', name: 'medium', desc: 'Medium increment: 0.10 cap: 20.00' },
  { id: 'low', name: 'low', desc: 'Low increment: 0.50 cap: 5.00' },
  { id: 'auto', name: 'auto', desc: 'Auto increment: sliding scale cap: sliding scale' },
  { id: 'dense', name: 'dense', desc: 'Dense increment: sliding scale cap: sliding scale' }
];

const AD_SIZES = [[970, 250], [300, 100], [300, 600], [970, 90], [300, 50], [300, 250], [728, 90], [336, 280], [160, 600]
, [970, 66], [320, 50], [320, 100], [300, 1050], [120, 600], [480, 60], [250, 250], [468, 60], [200, 200], [375, 350]
, [320, 480], [300, 168], [300, 75], [120, 20], [120, 30], [216, 54], [234, 60], [216, 36], [168, 28], [120, 90], [120, 60]
, [88, 31], [900, 90], [180, 150], [320, 250], [120, 240], [125, 125], [580, 400], [150, 125], [1350, 17], [480, 320]
, [200, 150], [1, 1], [320,400], [768,300], [1200,300], [320,200], [728,200], [1200,600], [600,420]];

const SCREEN_SIZES_WIDTH_RANGE = [
  {name: 'Mobile', maxSize: 767, id: '[0,0]'},
  {name: 'Tablet', maxSize: 992, id: '[767,0]'},
  {name: 'Desktop', maxSize: 2000, id: '[992,0]'}
];

const PrebidBidderSelector = ({source, scopedFormData}) => {
  const getIdentifiers = () => prebidBidders.find(x=>x.id === scopedFormData?.bidder)?.identifiers;
  const getIdentifiersOptional = () => prebidBidders.find(x=>x.id === scopedFormData?.bidder)?.identifiers_optional;
  const identifiers = getIdentifiers();
  const identifiersOptional = getIdentifiersOptional();
  let input = [];
  if (!['nobid', 'duration'].includes(scopedFormData?.bidder)) {
    if (identifiers) {
      identifiers.forEach (identifier => {
        input.push(<tr><td><TextInput source={`${source}.params.${identifier?.code || 'siteId'}`} label={`${identifier?.name} [${identifier?.code}] *` || 'Site ID'} fullWidth/></td></tr>);
      }); 
    }
    if (identifiersOptional) {
      identifiersOptional.forEach (identifier => {
        input.push(<tr><td><TextInput source={`${source}.params.${identifier?.code || 'siteId'}`} label={`${identifier?.name} [${identifier?.code}] (optional)` || 'Site ID'} fullWidth/></td></tr>);
      }); 
    }
  } else {
    if (identifiersOptional) {
      identifiersOptional.forEach (identifier => {
        input.push(<tr><td><TextInput source={`${source}.params.${identifier?.code || 'siteId'}`} label={`${identifier?.name} [${identifier?.code}] (optional)` || 'Site ID'} fullWidth/></td></tr>);
      }); 
    }
  }
  return (
      <div style={{display: 'flex', width: '100%', gap: '1px'}}>
        <table style={{width: '90%'}}>
          <tr><td><AutocompleteInput source={`${source}.bidder`} choices={prebidBidders} label='Bidder' /></td></tr>
          {input}
        </table>
      </div>
  )
}
const PrebidUserIds = () => {
  const record = useRecordContext();
  const userIds = record?.wrapup_config?.userIds || [];
  const output = [];
  output.push(<hr/>);
  userIds.forEach (userId => {
    const active = !userId.active ? ' (INACTIVE)' : '';
    output.push(<h4>{userId.name}{active}</h4>);
    output.push(`Module name: ${userId.moduleName}`);
    output.push(<br></br>);
    let params = userId.params;
    let keys = params && Object.keys(params);
    (keys && keys.length > 0) && output.push('Params');
    keys && keys.forEach (key => {
      if (typeof params[key]!=='object') output.push(<li>{key}<span style={{marginLeft: '20px'}}/>{params[key]}</li>);
      else output.push(<li>{key}<span style={{marginLeft: '20px'}}/>...</li>);
    });
    params = userId.storage;
    keys = params && Object.keys(params);
    (keys && keys.length > 0) && output.push('Storage');
    keys && keys.forEach (key => {
      if (typeof params[key]!=='object') output.push(<li>{key}<span style={{marginLeft: '20px'}}/>{params[key]}</li>);
      else output.push(<li>{key}<span style={{marginLeft: '20px'}}/>...</li>);
    });
    output.push(<hr/>);
  });
  return (
      <>{output}</>
  )
};
const generalModules = prebidGeneralModules.map(m => {
  if (prebidBaseModules.includes(m.bidderModule)) return { id: m.bidderModule, name: `${m.name} (${m.bidderModule}) *`, disabled: true };
  else return { id: m.bidderModule, name: `${m.name} (${m.bidderModule})` }
});
const recommendedModules = prebidRecommendedModules.map(m => {
  if (prebidBaseModules.includes(m.bidderModule)) return { id: m.bidderModule, name: `${m.name} (${m.bidderModule})`, disabled: true };
  else return { id: m.bidderModule, name: m.name }
});
const vendorSpecificModules = prebidVendorSpecificModules.map(m => {
  if (prebidBaseModules.includes(m.bidderModule)) return { id: m.bidderModule, name: `${m.name} (${m.bidderModule})`, disabled: true };
  else return { id: m.bidderModule, name: m.name }
});
const PrebidModules = () => {
  const record = useRecordContext();
  return (
      <div>
      <hr/>
      <h4>General Modules</h4>
      <SelectArrayInput source="wrapup_config.generalModules" choices={generalModules} label='General Modules' resettable fullWidth />
      <h4>Recommended Modules</h4>
      <SelectArrayInput source="wrapup_config.recommendedModules" choices={recommendedModules} label='Recommended Modules' resettable fullWidth />
      <h4>Vendor Specific Modules</h4>
      <SelectArrayInput source="wrapup_config.vendorSpecificModules" choices={vendorSpecificModules} label='Vendor Specific Modules' resettable fullWidth />
      </div>
  )
};

const validJSON = input => { if (input) { try { JSON.parse(input) } catch (e){ return "Invalid JSON: " + e} }};

const getAdSizeChoices = (type) => {
  let c = AD_SIZES.sort((a, b) => a[0] - b[0] || a[1] - b[1]).map(x=>({id: JSON.stringify(x), name: `${x[0]}x${x[1]}`}));
  return c;
  // return c.filter(x=> Number(x.name.split('x')[0]) < SCREEN_SIZES_WIDTH_RANGE.find(x => x.name === type).maxSize);
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: 500,
  },
}));

export function SiteTabs({permissions, ...props}) {
  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <AppBar position="static" color="default" style={{width: '250%'}}>
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          aria-label="full width tabs example"
        >
          <Tab label="Prebid Settings" />
          <Tab label="Ad Units" />
          <Tab label="User IDs" />
          <Tab label="Modules" />
          <Tab label="Optimizer Settings" />
          <Tab label="Wrapper Extensions" />
          <Tab label="Published Versions" />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0} dir={theme.direction} style={{width: '250%', border: '1px solid gray'}}>
        <div style={{display: 'flex', justifyContent: 'space-between', width: '100%'}}>
            <div style={{display: 'flex', gap:'20px'}}>
                <NumberInput source='wrapup_config.prebidTimeout' label='Prebid Timeout' defaultValue={3000}/>
            </div>
        </div>
        
        <NumberInput source='wrapup_config.siteId' label='site ID' defaultValue={props.record?.code} style={{display: 'none'}}/>
        <div style={{display: 'grid', width: '200%'}}>
          <BooleanInput source='wrapup_config.analyticsEnabled' label='Enable Analytics Adapter' style={{width: '25%'}}/>
          <BooleanInput source='wrapup_config.carbonizerEnabled' label='Enable Auction Optimizer' style={{width: '25%'}}/>
          <BooleanInput source='wrapup_config.s2sEnabled' label='Enable Prebid Server' style={{width: '25%'}}/>
          <br/>
          <NumberInput source='wrapup_config.syncDelay' label='Sync Delay' style={{width: '5%', marginTop: '-20px'}} defaultValue={3000}/>
          <span style={{marginTop: '-25px'}}>Delay in milliseconds for user syncing. Default: 3000</span>
          <br/>
          <SelectInput source='wrapup_config.priceGranularity' label='Price Granularity' style={{width: '25%'}}
          defaultValue='high' choices={prebidGranularityChoices} />
          <FormDataConsumer>
            {({ formData }) => { 
              if (formData) {
                return [<span style={{marginTop: '-25px'}}>{prebidGranularityChoices.find(c => c.id === formData.wrapup_config.priceGranularity).desc}</span>, <br/>, <br/>]
              }
            }}
          </FormDataConsumer>
          <BooleanInput source='wrapup_config.enableTIDs' label='Enable sharing of transaction IDs' style={{width: '25%'}}/>
          <a style={{marginTop: '-25px', color: 'white'}} href="https://docs.prebid.org/dev-docs/publisher-api-reference/setConfig.html#:~:text=Timers%20Work.-,Enable%20sharing%20of%20transaction%20IDs,-Prebid%20generates%20unique" target='_blank'>Prebid documentation...</a>
          <br/>
          <BooleanInput source='wrapup_config.customTargetingEnabled' label='Enable custom targeting. Use wuhb_pb instead of hb_pb' style={{width: '25%'}}/>
          <br/>
          <BooleanInput source='wrapup_config.cmpDisabled' label='Disable CMP (Not recommended. For testing only.)' style={{width: '45%'}} />
          <br/>
          <BooleanInput source='wrapup_config.singleRequestDisabled' label='Disable Single Request. Set to "true" for Single Page Applications like React or Angular.' style={{width: '25%'}}/>
          <FormDataConsumer>
            {({ formData }) => { 
              if (formData && formData.wrapup_config.singleRequestDisabled) {
                return ['1- Build a React component similar to the following in a file named "NoBidBannerAd.js"'
                  , <iframe src='NoBidBannerAd.html' width='700' height='400' style={{ border: "3px dotted lightgray" }}></iframe>
                  , <br/>
                  , '2- You can then use the component in your application as follows:'
                  , <iframe src='NoBidBannerAd_Usage.html' width='700' height='100' style={{ border: "3px dotted lightgray" }}></iframe>
                ]
              }
            }}
          </FormDataConsumer>
        </div>
      </TabPanel>
      <TabPanel value={value} index={1} dir={theme.direction} style={{width: '300%', border: '1px solid gray'}}>
        <div style={{width: '100%', padding: ' 0 20px'}}>
          <ArrayInput source="wrapup_config.adunits" label={false}>
              <SimpleFormIterator disableReordering>
                  <FormDataConsumer>
                  {({getSource, formData}) => {
                      return (
                      <Accordion style={{backgroundColor: '#3e3e3e', marginBottom: '20px'}} fullWidth>
                          <AccordionSummary expandIcon={<ExpandMore />}>
                              <TextField source={getSource("code")} />
                          </AccordionSummary>
                          <AccordionDetails style={{flexDirection: 'column'}}>
                              
                              <div style={{display: 'flex', gap: '20px'}}>
                                  <TextInput source={getSource("code")} label='Code' fullWidth/>
                                  <TextInput source={getSource("adunit")} label='Adunit' defaultValue={props.record?.adunit_path} fullWidth/>
                              </div>

                              <BooleanInput source={getSource("isVideo")} label='Is Video Unit' fullWidth/>

                              <div style={{display: 'flex', gap: '20px' }}>
                                  <div style={{width: '50%'}}>
                                      <h4>Banner Ad Sizes</h4>
                                      <div style={{border: '1px solid white', padding: '15px', display: 'flex', flexDirection: 'column' }}>
                                          <div style={{display: 'flex', width: '100%', gap: '15px'}}>
                                              <TextInput source={getSource(`sizeConfig[2].label`)} defaultValue='desktop' style={{display: 'none'}}/>
                                              <TextInput source={getSource(`sizeConfig[2].minViewPort`)} defaultValue={'[992,0]'} style={{display: 'none'}}/>
                                              <SelectArrayInput source={getSource(`sizeConfig[2].sizes`)} choices={getAdSizeChoices('Desktop')} label='Desktop Ad Sizes' resettable fullWidth/>
                                          </div>
                                          <div style={{display: 'flex', width: '100%', gap: '15px'}}>
                                              <TextInput source={getSource(`sizeConfig[0].label`)} defaultValue='mobile' style={{display: 'none'}}/>
                                              <TextInput source={getSource(`sizeConfig[0].minViewPort`)} defaultValue={'[0,0]'} style={{display: 'none'}}/>
                                              <SelectArrayInput source={getSource(`sizeConfig[0].sizes`)} choices={getAdSizeChoices('Mobile')} label='Mobile Ad Sizes' resettable fullWidth/>
                                          </div>
                                          <div style={{display: 'flex', width: '100%', gap: '15px'}}>
                                              <TextInput source={getSource(`sizeConfig[1].label`)} defaultValue='tablet' style={{display: 'none'}}/>
                                              <TextInput source={getSource(`sizeConfig[1].minViewPort`)} defaultValue={'[767,0]'} style={{display: 'none'}}/>
                                              <SelectArrayInput source={getSource(`sizeConfig[1].sizes`)} choices={getAdSizeChoices('Tablet')} label='Tablet Ad Sizes' resettable fullWidth/>
                                          </div>
                                      </div>
                                  </div>

                                  <div style={{width: '50%'}}>
                                    <h4>Bidders</h4>
                                    <div style={{border: '1px solid white', padding: '15px', display: 'flex', flexDirection: 'column' }}>
                                        <ArrayInput source={getSource("bids")} label={false}>
                                            <SimpleFormIterator disableReordering>
                                            <FormDataConsumer>
                                                {({id, scopedFormData}) => (
                                                    <PrebidBidderSelector source={id} scopedFormData={scopedFormData}/>
                                                )}
                                            </FormDataConsumer>
                                            </SimpleFormIterator>
                                        </ArrayInput>
                                    </div>
                                  </div>
                                  
                              </div>
                              <br/>
                              <Accordion style={{width: '100%', height: '1%'}}>
                                <AccordionSummary expandIcon={<ExpandMore />}>Behavior</AccordionSummary>
                                <AccordionDetails>
                                  <div style={{display: 'flex', columnGap: '20px'}}>
                                    <div style={{width: '50%'}}>
                                        Lazy Load<div style={{fontSize: 'x-small'}}>The Lazy Loading behavior helps reduce page latency and ad value (CPM) because it delays making Ad Requests until the user is close by X (Margin) pixels of the Ad slot location.</div>
                                        <div style={{border: '1px solid white', padding: '10px', display: 'flex', flexDirection: 'column'}}>
                                            <BooleanInput source={getSource("lazyLoad.enabled")} label='Enable Lazy Load'/>
                                            <NumberInput source={getSource("lazyLoad.margin")} label='Margin' style={{width: '30%'}} helperText='This is the marging in pixels used to trigger the Ad request.'/>
                                        </div>
                                    </div>
                                    <div style={{width: '50%', height: '1%'}}>
                                        Autorefresh<div style={{fontSize: 'x-small'}}>The Auto Refresh behavior helps in increasing inventory volume. Combined with Viewability and Lazy load, it becomes an effective way in increasing the volume of Viewable inventory.</div>
                                        <div style={{border: '1px solid white', padding: '15px', display: 'flex', flexDirection: 'column'}}>
                                            <BooleanInput source={getSource("autorefresh.enabled")} label='Enable Auto Refresh'/>
                                            <div style={{gap: '10px' }}>
                                              <div style={{display: 'grid'}}>
                                              <div><NumberInput source={getSource("autorefresh.threshold")} label='Threshold %' style={{width: '30%'}} helperText='Percentage of the Adunit visible to be considered In-View.'/></div>
                                              </div>
                                              <div style={{display: 'grid'}}>
                                                <div><NumberInput source={getSource("autorefresh.ttv")} label='Viewability time (seconds)' style={{width: '30%'}} helperText='How long the system should wait until a Refresh is triggered.'/></div>
                                              </div>
                                              <div style={{display: 'grid'}}>
                                                <div><NumberInput source={getSource("autorefresh.stopLineItem")} label='Stop Line Item' style={{width: '50%'}} helperText='This is a GAM Line Item that the system checks to determine if it should stop refresh. This is done to stop refreshing when an unfilled impression is served.'/></div>
                                              </div>
                                              <div style={{display: 'grid'}}>
                                                <div><NumberInput source={getSource("autorefresh.impressionsLimit")} label='Impressions Limit' style={{width: '30%'}} helperText='The system should only refresh un to the total "Impressions Limit".'/></div>
                                              </div>
                                            </div>
                                        </div>
                                    </div>
                                  </div>
                                </AccordionDetails>
                              </Accordion>
                              <br/>
                              <Accordion style={{width: '100%', height: '1%'}}>
                                <AccordionSummary expandIcon={<ExpandMore />}>Advanced Settings</AccordionSummary>
                                <AccordionDetails style={{display: 'grid'}}>
                                    <div style={{width: '100%'}}>
                                      Ad Label Settings
                                      <TextInput style={{marginBottom: '8px'}} source={getSource("sponsor.label")} label='Ad Label' fullWidth
                                      defaultValue='Advertisement'/>
                                      <TextInput source={getSource("sponsor.style")} label='Ad Label Style' minRows={3} validate={ validJSON } multiline fullWidth
                                      defaultValue='{"color": "gray", "fontSize": "x-small", "justifyContent": "center", "display": "grid", "paddingBottom": "5px"}'/>
                                    </div>
                                  
                                    <div style={{width: '100%'}}>
                                      Styles
                                      <TextInput source={getSource("style")} label='Container Style' fullWidth validate={ validJSON } multiline
                                      defaultValue='{"justifyContent": "center", "display": "grid"}'/>
                                      <TextInput source={getSource("divStyle")} label='Ad Div Style' fullWidth validate={ validJSON } multiline/>
                                    </div>
                                </AccordionDetails>
                              </Accordion>
                              
                          </AccordionDetails>
                      </Accordion>
                      )
                  }
                  }
                  </FormDataConsumer>
              </SimpleFormIterator>
          </ArrayInput>
        </div>
      </TabPanel>
      <TabPanel value={value} index={2} dir={theme.direction} style={{width: '250%', border: '1px solid gray'}}>
        <Button style={{ width: '50%' }} href="https://docs.prebid.org/dev-docs/modules/userId.html" label="Prebid Documentation - User ID Module for Header Bidding" target="_blank" startIcon={<LinkIcon />} />
        <div style={{padding: '0 20px'}}>
        <PrebidUserIds />
        </div>
      </TabPanel>

      <TabPanel value={value} index={3} dir={theme.direction} style={{width: '250%', border: '1px solid gray'}}>
        <Button style={{ width: '50%' }} href="https://docs.prebid.org/dev-docs/modules/" label="Prebid.js Documentation - Prebid.js Modules for Header Bidding" target="_blank" startIcon={<LinkIcon />} />
        <div style={{padding: '0 20px'}}>
          <PrebidModules />
        </div>
      </TabPanel>
      
      <TabPanel value={value} index={4} dir={theme.direction} style={{width: '250%', border: '1px solid gray'}}>
        <div style={{display: 'flex', gap: '20px'}}>
          <div style={{width: '50%'}}>
            <BooleanInput source='wrapup_config.carbonizerEnabled' label='Enable Auction Optimizer' style={{width: '50%'}}/>
            
            <div style={{display: 'grid'}}>
            <div>Minimum IMPRESSIONS globally set to 1 impression by default.</div>
            <NumberInput source="wrapup_config.carbonizer.impressions_minimum" label="Minimum Impressions" style={{width: '50%'}}
                helperText="Block inventory where impressions is less or equal to the minimum" />
            </div>

            <br/>
            <div style={{display: 'grid'}}>
            <div>Minimum REVENUE globally set to $0.001 by default.</div>
            <NumberInput source="wrapup_config.carbonizer.revenue_minimum" label="Minimum Revenue ($)" style={{width: '50%'}}
                helperText="Block inventory where revenue is less or equal to the minimum" />
            </div>

            <br/>
            <div style={{display: 'grid'}}>
            <div>Minimum RESPONSE RATE defined as #bid responses / #bid requests.</div>
            <NumberInput source="wrapup_config.carbonizer.bid_responses_rate_minimum" label="Minimum Response Rate %" style={{width: '50%'}}
                helperText="Block inventory where bid response rate is less or equal to the minimum (bid responses/bid requests)"/>
            </div>

            {/* <br/>
            <div style={{display: 'grid'}}>
            <div>Minimum FILL RATE defined as #impressions / #ad requests.</div>
            <NumberInput source="wrapup_config.carbonizer.fill_rate_minimum" label="Minimum Fill Rate %" style={{width: '50%'}}
                helperText="Block inventory where fill rate is less or equal to the minimum (impressions/ad requests)."/>
            </div> */}

            <br/>
						<div style={{display: 'grid'}}>
						<div>Minimum RPM defined as Revenue per Million Bid Requests (1,000,000 * $revenue / #bid requests).</div>
						<NumberInput source="wrapup_config.carbonizer.rpm_bid_requests_minimum" label="Minimum RPM Rate ($)" style={{width: '50%'}}
								helperText="Block inventory where RPM is less or equal to the minimum (1,000,000 * $revenue/#bid requests)."/>
						</div>
          </div>
          <div style={{width: '50%'}}>
            The Auction Optimizer minimizes wasteful requests resulting in: faster page speed, increased profitability and carbon emissions reduction.
            <ul>
            <li>The Auction Optimizer uses the last 10 days including today's data to build the optimization model.</li>
            <li>The Optimizer uses a rules based system to determine the best inventory "pockets".</li>
            <li>Currently the following inventory parameter are part of the selection algorithm:</li>
              <ul>
                <li>Bidder</li>
                <li>Site</li>
                <li>Country</li>
                <li>Device</li>
                <li>Browser</li>
                <li>Ad Type (Banner or Video)</li>
                <li>Ad size (Coming soon)</li>
              </ul>
              <li>The auction optimizer runs constantly to "optimize" your inventory.</li>
              <li>The auction optimizer runs an A/B test experiment to monitor the optimization results.</li>
            </ul>
            <hr/>
            <h4>Developers Implementation Notes</h4>
            There are 2 ways to use the NoBid Auction Optimizer:
            <ol>
              <li>If you are using the NoBid Prebid Wrapper, the Optimizer is already implemented and the developers don't need to code any changes.</li>
              <li>If you are NOT using the NoBid Prebid Wrapper, you would need to enable the NoBid Analytics Adapter in your Prebid wrapper.
                Next, you need to turn on the Auction Optimizer in this section and implement the following lines of code in your site.
              <pre><code>{'if (typeof nobidCarbonizer !== \'undefined\') {\n' +
                '   nobidCarbonizer.carbonizeAdunits(adunits);\n' +
              '}'
              }
              </code></pre>
              This code is to be applied on the set of adunits you have put in place for your page.
              <br/>Please contact Support for any questions related to the implementation.
              </li>
            </ol>
          </div>
        </div>
      </TabPanel>

      <TabPanel value={value} index={5} dir={theme.direction} style={{width: '250%', border: '1px solid gray'}}>
      Scripts to load along with the NoBId Prebid Wrapper
      <ArrayInput source="wrapup_config.extension_scripts" label={false}>
      <SimpleFormIterator>
        <TextInput label="Script full URL"
          source="url"
          helperText="Enter here the full script URL to load along the NoBid Prebid Wrapper. All scripts are load asynchronously."
          style={{ width: '80%' }}
        />
      </SimpleFormIterator>
      </ArrayInput>
      </TabPanel>

      <TabPanel value={value} index={6} dir={theme.direction} style={{width: '250%', border: '1px solid gray'}}>
        { props.record?.wrapup_config?.deployedVersions?.length > 0 && 
        <ArrayField source="wrapup_config.deployedVersions" style={{ width: '100%' }} >
            <Datagrid>
                <FunctionField label='Wrapper' render={record => <a href={record.url} target="_blank" style={{color: 'white'}}>{ record.url } [Download]</a>} />
                <FunctionField label='Preview' render={record => record.preview ? <a href={`${record.preview}&cb=${Math.ceil(9999*Math.random())}`} target="_blank" style={{color: 'white'}}>Preview</a> : ''} />
                <DateField label='Time' source='timeStamp' showTime/>
                <TextField label='User' source='user.name'/>
            </Datagrid>
        </ArrayField>
        }
      </TabPanel>

    </div>
  );
}